import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

//Constantes
const dataInicial = {
    estados : {},
    municipios : {},
    codigosPostales : {},
    colonias: {},
    localidades: {},
    calles: {}
}

//types
const OBTENER_ESTADOS_EXITO = 'OBTENER_ESTADOS_EXITO'
const OBTENER_MUNICIPIOS_EXITOS = 'OBTENER_MUNICIPIOS_EXITOS'
const OBTENER_CODIGOS_POSTALES_EXITO = 'OBTENER_CODIGOS_POSTALES_EXITO' 
const OBTENER_COLONIAS_EXITO = 'OBTENER_COLONIAS_EXITO'
const OBTENER_LOCALIDAD_EXITO = 'OBTENER_LOCALIDAD_EXITO'
const OBTENER_CALLES_EXITO = 'OBTENER_CALLES_EXITO'

export const obtenerCallesPorClavesEstadoMunicipioLocalidad = createAsyncThunk(
    OBTENER_CALLES_EXITO,
    async (data) => {
        try {
            const {clave_estado, clave_municipio, clave_localidad} = data
             
            const fullUrl = host + `Copomex/getVialidadesByClavesEstadoMunicipioLocalidad/clave_estado=${clave_estado}&clave_municipio=${clave_municipio}&clave_localidad=${clave_localidad}`
            const callesResult = await axios.get(fullUrl)
            return callesResult.data.data.response.vialidad
        } catch (error) {
            console.log(error);
        }
    }
)

export const obtenerLocalidadesPorEstadoYMunicipioApi = createAsyncThunk(
    OBTENER_LOCALIDAD_EXITO,
    async (data) => {
        try {
            const {estado, municipio} = data

            const fullUrl = host + `Copomex/getLocalidadByEstadoAndMunicipio/estado=${estado}&municipio=${municipio}`
            const localidadesResult = await axios.get(fullUrl)
            const arrayLocalidades = [];
            
            for (var i in localidadesResult.data.data.response.localidad_clave) {
                arrayLocalidades.push({id:Number(localidadesResult.data.data.response.localidad_clave[i]), localidad:i, clave:localidadesResult.data.data.response.localidad_clave[i]});
            }

            return arrayLocalidades
        } catch (error) {
            console.log(error);
        }
    }
)

export const obtenerColoniasPorCpApi = createAsyncThunk(
    OBTENER_COLONIAS_EXITO,
    async (cp) => {
        try {
            const fullUrl = host + `Copomex/getColoniaByCodigoPostal/${cp}`
            const coloniasResult = await axios.get(fullUrl)
            return coloniasResult.data.data.response.colonia
        } catch (error) {
            console.log(error);
        }
    }
)

export const obtenerCPsPorMunicipioApi = createAsyncThunk(
    OBTENER_CODIGOS_POSTALES_EXITO,
    async (municipio) => {
        try {
            const fullUrl = host + `Copomex/getCodigosPostalesByMunicipio/${municipio}`
            const cpsResult = await axios.get(fullUrl)
            return cpsResult.data.data.response.cp
        } catch (error) {
            console.log(error);
        }
    }
)


export const obtenerMunicipiosConClavePorEstadoApi = createAsyncThunk(
    OBTENER_MUNICIPIOS_EXITOS,
    async (estado) => {
        try {
            const fullUrl = host + `Copomex/getMunicipiosByNombreEstado/${estado}`
            const municipiosResult = await axios.get(fullUrl)
            const arrayMunicipios = [];
            for (let i in municipiosResult.data.data.response.municipio_clave) {
                arrayMunicipios.push({id:Number(municipiosResult.data.data.response.municipio_clave[i]),municipio:i, clave:municipiosResult.data.data.response.municipio_clave[i]});
            }
            var arrayMunicipiosOrdenados = sortJSON(arrayMunicipios, 'municipio', 'asc');
            return arrayMunicipiosOrdenados
        } catch (error) {
            console.log(error);
        }
    }
)

export const obtenerEstadosApi = createAsyncThunk(
    OBTENER_ESTADOS_EXITO,
    async () => {
        try {
            const fullUrl = host + `Copomex/getEstadosSinClave`
            const estadosResult = await axios.get(fullUrl)
            return estadosResult.data.data.response.estado
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerEstadosConClaveApi = createAsyncThunk(
    OBTENER_ESTADOS_EXITO,
    async () => {
        try {
            const fullUrl = host + `Copomex/getEstados`
            const estadosResult = await axios.get(fullUrl)
            const arrayEstados = [];
            for (var i in estadosResult.data.data.response.estado_clave) {
                arrayEstados.push([i, estadosResult.data.data.response.estado_clave[i]]);
            }
            return arrayEstados
        } catch (error) {
            console.log(error);
        }
    }
)

function sortJSON(data, key, orden) {
    return data.sort(function (a, b) {
        var x = a[key],
        y = b[key];

        if (orden === 'asc') {
            return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        }

        if (orden === 'desc') {
            return ((x > y) ? -1 : ((x < y) ? 1 : 0));
        }
    });
}
export const copomexSlice = createSlice({
    name: 'copomexSlice',
    initialState: dataInicial,
    reducers: {
        setMunicipiosApi(state,{payload}) {
            state.municipios = payload
        },
        setCodigosPostalesApi(state,{payload}) {
            state.codigosPostales = payload
        },
        setColoniasApi(state,{payload}) {
            state.colonias = payload
        },
        setLocalidadesApi(state,{payload}) {
            state.localidades = payload
        },
        setCallesApi(state,{payload}) {
            state.calles = payload
        },
        resetDataCopomex(state, { payload }) {
            return dataInicial
        },
    },
    extraReducers: {
        [obtenerEstadosApi.fulfilled] : (state, {payload}) => {
            state.estados = payload
        },
        [obtenerEstadosConClaveApi.fulfilled] : (state, {payload}) => {
            state.estados = payload
        },
        [obtenerMunicipiosConClavePorEstadoApi.fulfilled] : (state, {payload}) => {
            state.municipios = payload
        },
        [obtenerCPsPorMunicipioApi.fulfilled] : (state, {payload}) => {
            state.codigosPostales = payload
        },
        [obtenerColoniasPorCpApi.fulfilled] : (state, {payload}) => {
            state.colonias = payload
        },
        [obtenerLocalidadesPorEstadoYMunicipioApi.fulfilled] : (state, {payload}) => {
            state.localidades = payload
        },
        [obtenerCallesPorClavesEstadoMunicipioLocalidad.fulfilled] : (state, {payload}) => {
            if(payload !== undefined){
                state.calles = payload
            }else{
                state.calles = []
            }
        },
    }
})

export const {
    setMunicipiosApi, setCodigosPostalesApi, setColoniasApi, setLocalidadesApi, setCallesApi,resetDataCopomex
} = copomexSlice.actions
export const CopomexReducer = copomexSlice.reducer